'use client';

/**
 * ObeyaCostPlanHeaderCard — single card wrapping the KPI reading row and
 * the save/compare versions bar as two rows of ONE card, not two
 * separately-boxed cards stacked with a grid gap between them.
 *
 * Composes `ObeyaCostPlanKpisCard` and `ObeyaCostPlanVersionsCard`
 * unchanged — same hooks, same data, same content_key exports for scene
 * fidelity, same behaviour. This card owns the chrome (bg-card, border,
 * rounded, the divider between the two rows); the two inner components
 * render plain content with no chrome of their own, same as they did
 * before either was ever boxed.
 *
 * Replaces the two separate `kpis`/`versions` PlacementSpecs on both
 * mode1_costplan ("Cost Summary") and mode1_costplan_output ("Cost
 * Plan") with one `header` placement — the two presets already used the
 * identical pair, adjacent, same width, every time; this just makes
 * that pairing a real card instead of a layout coincidence.
 *
 * @see klyde_ipe/components/canvas/cards/obeya/costplan-kpi-row-card.tsx
 * @see klyde_ipe/components/canvas/cards/obeya/costplan-versions-bar-card.tsx
 *
 * @component_role: Card
 * @component_type: Card Renderer
 * @domain: Canvas / Obeya
 * @layer: presentation
 */

import { ObeyaCostPlanKpisCard } from './costplan-kpi-row-card';
import { ObeyaCostPlanVersionsCard } from './costplan-versions-bar-card';

export function ObeyaCostPlanHeaderCard() {
  return (
    <div className="h-full flex flex-col bg-card rounded-xl border border-border divide-y divide-border overflow-hidden">
      <div className="px-3 py-2 flex-1 min-h-0 flex items-center">
        <ObeyaCostPlanKpisCard />
      </div>
      <div className="px-3 py-2 flex-1 min-h-0 flex items-center">
        <ObeyaCostPlanVersionsCard />
      </div>
    </div>
  );
}
